import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { Contrato } from '../modelo/contrato';
import { Parcela } from '../modelo/parcela';
import { TreatDate } from '../util/treatDate';
import { ParcelaDetalhe } from './components/detalhe-parcela/detalhe-parcela.model';
import { PagamentoParcelaService, PagamentosParcelaResultado } from '../services/pagamento-parcela.service';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Config } from '../services/config';

declare var $: any;

@Component({
  selector: 'app-extrato-contrato',
  templateUrl: './extrato-contrato.component.html',
  styleUrls: ['./extrato.component.css']
})


export class ExtratoContratoComponent extends AbstractComponent implements OnInit {

  contrato: Contrato;
  emitidoEm: string;
  parcelaAberta: number | null = null;
  private pagamentosPorParcela: { [numeroParcela: number]: PagamentosParcelaResultado } = {};

  constructor(
    private sessaoService: SessaoService,
    private pagamentoParcelaService: PagamentoParcelaService,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  /**
   * Método chamado ao inicializar o componente
   */
  ngOnInit() {
    //Scroll top

    window.scrollTo(0, 0);
    // carrega as informações do contrato da sessão
    this.contrato = JSON.parse(sessionStorage.getItem("extratoContrato"));
    this.emitidoEm = TreatDate.getDataHora();

    // Pre-carrega os pagamentos das parcelas pagas parcialmente para exibir o Valor pago atualizado na listagem
    this.carregarPagamentosParcelasParciais();

    // Mmonta a popup com o conteúdo do relatório
    $('.modal').modal();

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  detalhes(){
    $("#tarifa").slideToggle();
    $("#btnTarifa").toggleClass("active");
  }

  listaProduto(){
    $("#listaProduto").slideToggle();
    $("#btnListaProduto").toggleClass("active");
  }

  exibirBotaoAdicionarParcela(parcela: any): boolean {
    if (!parcela || !parcela.situacao || !parcela.situacao.dsSituacao) {
      return false;
    }

    const situacao = String(parcela.situacao.dsSituacao).trim().toUpperCase();
    return situacao === 'PGTO PARCIAL';
  }

  obterSituacaoExibicao(situacao: string): string {
    return situacao && situacao.trim().toUpperCase() === 'PGTO PARCIAL'
      ? 'Pago Parcialmente'
      : situacao;
  }

  obterLabelTotalRecebido(parcela: any): string {
    return this.exibirBotaoAdicionarParcela(parcela) ? 'Valor pago atualizado' : 'Total Recebido';
  }

  obterValorTotalRecebido(parcela: any): string {
    if (this.exibirBotaoAdicionarParcela(parcela)) {
      const resultado = this.pagamentosPorParcela[parcela.nuParcela];
      const valor = resultado
        ? resultado.totalPagamentos
        : this.parseValorNumerico(parcela.vrRecebidoFormatado || parcela.vrRecebido);

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor || 0);
    }

    return 'R$ ' + (parcela.vrRecebidoFormatado || '');
  }

  onClickAdicionarParcela(parcela: any): void {
    this.toggleDetalhes(parcela.nuParcela);
  }

  private parseValorNumerico(valor: any): number {
    if (valor === null || valor === undefined) {
      return 0;
    }

    const valorTexto = String(valor)
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^0-9.-]/g, '');
    const valorNumero = Number(valorTexto);

    return isNaN(valorNumero) ? 0 : valorNumero;
  }

  /**
   * Realiza a impressão da página
   */
  imprimir() {
    var ua = window.navigator.userAgent;
    if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Firefox/') > 0) {
      window.print();
      var conteudo = $('.relExtratoContratoContent').html();
      $('.relExtratoContrato').html(conteudo);
      $('.modal .caminhoPao').hide();
      $('.modal .relHide').hide();
      $(".modal .btn-details").hide();
      $(".modal .ico-help-outline-black").hide();
      $(".modal .details").show();
      $(".modal .details > div").css({"background-color": "transparent", "margin-left": "20px","margin-right":"200px","padding-left":"10px"});
      $(".modal  h1 span").css({"padding": "10px 20px"});
      $(".modal  h1 ").css({"padding": "10px 0 15px 1px"});
      $(".modal  h2").css({"margin-left": "-1px"});
      $(".modal div.linha-divisao hr").css({"display": "inherit"});
      $(".modal .invisible").hide();
      $('#m-rel-extrato-contrato').modal('open');
    }
    else {
      $(".page").removeClass("toggled");
      window.print();
    }
  }

  toggleDetalhes(numeroParcela: number): void {
    const abrindo = this.parcelaAberta !== numeroParcela;

    if (!abrindo) {
      this.parcelaAberta = null;
      return;
    }

    // O detalhamento so e aberto apos o retorno com sucesso da consulta de pagamentos
    this.carregarPagamentosParcela(numeroParcela);
  }

  private carregarPagamentosParcelasParciais(): void {
    if (!this.contrato || !this.contrato.listaParcela) {
      return;
    }

    this.contrato.listaParcela
      .filter((parcela: Parcela) => this.exibirBotaoAdicionarParcela(parcela))
      .forEach((parcela: Parcela) => this.carregarPagamentosParcela(parcela.nuParcela, false, true));
  }

  private carregarPagamentosParcela(numeroParcela: number, abrirAoConcluir: boolean = true, silencioso: boolean = false): void {
    if (!this.contrato) {
      if (!silencioso) {
        this.exibirErroConsultaPagamentos();
      }
      return;
    }

    if (this.pagamentosPorParcela[numeroParcela]) {
      if (abrirAoConcluir) {
        this.parcelaAberta = numeroParcela;
      }
      return;
    }

    this.pagamentoParcelaService
      .listarPagamentosParcela(this.contrato.nuContrato, numeroParcela)
      .subscribe(
        (resultado: PagamentosParcelaResultado) => {
          this.pagamentosPorParcela[numeroParcela] = resultado;
          if (abrirAoConcluir) {
            this.parcelaAberta = numeroParcela;
          }
        },
        (error: Response) => {
          if (abrirAoConcluir) {
            this.parcelaAberta = null;
          }
          if (!silencioso) {
            this.exibirErroConsultaPagamentos(error);
          }
        }
      );
  }

  /**
   * Exibe a mensagem padrao de erro quando nao e possivel consultar os pagamentos da parcela
   */
  private exibirErroConsultaPagamentos(error?: Response): void {
    const status = error && error.status ? error.status : 0;

    if (status !== 0 && (status < 400 || status > 599)) {
      return;
    }

    this.dialog.open(BraAlertComponent, {
      width: Config.POPUP_50VW,
      data: {
        mensagem: this.getMensagem('ERRO_CHAMADA_SERVICO')
      }
    });
  }

  fecharDetalhes(): void {
    this.parcelaAberta = null;
  }

  obterDetalheParcela(parcela: Parcela): ParcelaDetalhe {
    const resultado = this.pagamentosPorParcela[parcela.nuParcela];
    const pagamentosReais = resultado ? resultado.pagamentos : null;

    return {
      numeroParcela: parcela.nuParcela,
      dataVencimento: parcela.dtVencimentoFormatada,
      situacao: this.obterSituacaoExibicao(parcela.situacao && parcela.situacao.dsSituacao ? parcela.situacao.dsSituacao : ''),
      valorParcela: this.parseValorNumerico(parcela.vrParcelaFormatado || parcela.vrParcela),
      jurosRemuneratorios: this.parseValorNumerico(parcela.vrEncargosRemuFormatado || parcela.vrEncargosRemu),
      jurosMoratorios: this.parseValorNumerico(parcela.vrEncargosMoraFormatado || parcela.vrEncargosMora),
      multaAtraso: this.parseValorNumerico(parcela.vrTaxaMultaFormatado || parcela.vrTaxaMulta),
      totalEncargos: this.parseValorNumerico(parcela.vrEncargosParcelasVencidasPendentesFormatado || parcela.vrEncargosParcelasVencidasPendentes),
      valorPagoAtualizado: resultado ? resultado.totalPagamentos : this.parseValorNumerico(parcela.vrRecebidoFormatado || parcela.vrRecebido),
      valorRestante: resultado && resultado.quantoFaltaPagar !== undefined ? resultado.quantoFaltaPagar : this.parseValorNumerico(parcela.vrAtualizadoFormatado || parcela.vrAtualizado),
      pagamentosParciais: pagamentosReais && pagamentosReais.length ? pagamentosReais : [
        {
          numero: 1,
          dataPagamento: parcela.dtPagamentoFormatada || parcela.dtPagamento,
          valorPrincipal: 0,
          jurosRemuneratorios: 0,
          jurosMoratorios: 0,
          multa: 0,
          iof: 0,
          valorPagoParcial: this.parseValorNumerico(parcela.vrRecebidoFormatado || parcela.vrRecebido),
          formaPagamento: 'Boleto'
        }
      ]
    };
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-extrato-cli/extrato-contrato.component.ts